import { Component, ViewChild } from '@angular/core';
import {
  AbstractControl,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  NgForm,
  ValidationErrors,
  ValidatorFn,
  Validators,
} from '@angular/forms';
import { UserFreemium } from '../../../auth/models/user.model';
import { UserService } from '../../../user-admin/services/user.service';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { CategoryService } from '../../services/categories.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { numberValidator } from 'projects/marketpro-ui/src/app/modules/auth/validators/number.validator';
@Component({
  selector: 'mpro-freemium-register',
  templateUrl: './freemium-register.component.html',
  styleUrls: ['./freemium-register.component.scss'],
})
export class FreemiumRegisterComponent {
  public currentYear: number;
  private forbiddenEmailString: string = 'gmail';
  public faArrowLeft = faArrowLeft;
  public registryStep: 'USER' | 'CATEGORY' | 'SUCCESS' | 'ERROR' = 'USER';
  public categories;

  public form: UntypedFormGroup;
  public categorySelector: UntypedFormControl;
  public loading: boolean = false;
  public userDataConfirmed: boolean = false;
  public emailAlreadyInUse = false;
  public userExists = false;

  constructor(
    private fb: UntypedFormBuilder,
    public userService: UserService,
    private categoryService: CategoryService,
    private router: Router
  ) {
    this.currentYear = new Date().getFullYear();
  }

  public ngOnInit() {
    this.initializeForm();
    this.categoryService.getCategories('', true).subscribe((categories) => {
      this.categories = categories;
    });
  }

  public initializeForm() {
    this.form = this.fb.group({
      userData: this.fb.group({
        firstName: ['', Validators.required],
        lastName: ['', Validators.required],
        organizationName: ['', Validators.required],
        email: ['', [Validators.required, Validators.email]],
        phoneNumber: ['', [numberValidator()]],
        contactMe: [false],
      }),
      categorySelector: ['', Validators.required],
    });
  }

  public onUserDataSubmit() {
    this.userDataConfirmed = true;
    if (!this.form.get('userData')?.valid) {
      return;
    }

    if (
      this.form
        .get('userData')
        ?.get('email')
        ?.value.includes(this.forbiddenEmailString)
    ) {
      this.form.get('userData')?.get('email')?.clearValidators();
      this.form
        .get('userData')
        ?.get('email')
        ?.setValidators([
          Validators.required,
          Validators.email,
          this.forbiddenEmailValidator(),
        ]);
      this.form
        .get('userData')
        ?.get('email')
        ?.setErrors({ personalEmail: true });
      return;
    }

    this.registryStep = 'CATEGORY';
  }

  public stepBack() {
    this.registryStep = 'USER';
  }

  public onSubmit() {
    this.loading = true;
    const userFreemiumRequest: UserFreemium = {
      ...this.form.get('userData')?.value,
      phoneNumber: this.form
        .get('userData')
        ?.get('phoneNumber')
        ?.value.toString(),
      categoryCoicopCode: this.form.get('categorySelector')?.value,
    };
    this.userService.registerFreemiumUser(userFreemiumRequest).subscribe(
      () => {
        this.registryStep = 'SUCCESS';
        this.loading = false;
      },
      (err: HttpErrorResponse) => {
        if (err.status === 409) {
          this.emailAlreadyInUse = true;
        }
        if (err.status === 423) {
          this.userExists = true;
        }
        this.registryStep = 'ERROR';
        this.loading = false;
      }
    );
  }

  public resetForm() {
    this.form.reset();
    this.registryStep = 'USER';
  }

  public redirectLogIn() {
    this.router.navigate(['/login']);
  }

  public onCategorySelected(category, isChecked: boolean) {
    this.form.get('categorySelector')?.setValue(category.code);
  }

  public isChecked(projection): boolean {
    return this.form.get('categorySelector')?.value === projection.code;
  }

  private forbiddenEmailValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const forbidden = control.value.includes(this.forbiddenEmailString);
      return forbidden ? { forbiddenName: { value: control.value } } : null;
    };
  }
}
